<template>
  <div>
    <p>
      <select v-model="product">
        <option v-for="p in products" :key="p.name" :value="p">
          {{ p.name }}
        </option>
      </select>
    </p>
    <OTPCredit v-if="product" :product="product" />
  </div>
</template>

<script>
import OTPCredit from '@/components/credits/OTPCredit.vue'

export default {
  name: 'OTPCreditCheckout',
  components: {
    OTPCredit,
  },
  data: () => {
    return {
      product: null,
    }
  },
  props: {
    products: {
      type: Array,
      require: true,
      default: () => [],
    },
  },
  mounted() {
    this.product = this.products[0]
  },
}
</script>
